<template>
    <div>		               
        <Panel header="Informações gerais" class="p-mt-3 p-mb-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-6 p-md-4">
                    <label for="razaoSocial">Nome</label>
                    <InputText v-model.trim="cliente.nome" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !cliente.nome">Informe o Nome</small>
                </div>
                <div class="p-field p-col-6 p-md-3">
                    <label for="razaoSocial">E-mail</label>
                    <InputText v-model.trim="cliente.email" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !cliente.email">Informe o E-mail</small>
                </div>
                <div class="p-field p-col-6 p-md-5">
                    <label for="nomeFantasia">Razão social</label>
                    <InputText v-model.trim="cliente.razaoSocial" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !cliente.razaoSocial">Informe a Razão social</small>
                </div>
                <div class="p-field p-col-3 p-md-3">
                    <label>CNPJ</label>
                    <InputMask mask="99.999.999/9999-99" v-model="cliente.cnpj"  placeholder="__.___.___./____-__" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !cliente.cnpj && !cliente.cpf">Informe o CNPJ ou CPF</small>
                </div>
                <div class="p-field p-col-3 p-md-3">
                    <label>CPF</label>
                    <InputMask mask="999.999.999-99" v-model="cliente.cpf" placeholder="___.___.___-__" autocomplete="off" />
                    <small class="p-invalid" v-if="enviandoForm && !cliente.cnpj && !cliente.cpf">Informe o CNPJ ou CPF</small>
                </div>                                             
                <div class="p-field p-col-3 p-md-3">
                    <label>Telefone</label>
                    <InputMask mask="(99) 9999-9999" v-model="cliente.telefone" placeholder="(__) ____-____" autocomplete="off" />                            
                </div>
                <div class="p-field p-col-3">
                    <label>Celular</label>
                    <InputMask mask="(99) 99999-9999" v-model="cliente.celular" placeholder="(__) _____-____" autocomplete="off" />
                </div> 
                <div class="p-field p-col-2">
                    <label>Estado</label>
                    <InputText v-model.trim="cliente.estado" autocomplete="off" maxlength ="2"/>
                </div> 
                <div class="p-field p-col-3">
                    <label>Cidade</label>
                    <InputText v-model.trim="cliente.cidade" autocomplete="off" maxlength ="70"/>
                </div>     
                <div class="p-field p-col-7">
                    <label>Endereço</label>
                    <InputText v-model.trim="cliente.endereco" autocomplete="off" maxlength ="200"/>
                </div>                     
                <div class="p-field-checkbox p-col-1" v-if="cliente.dataCadastro">                        
                    <Checkbox v-model="cliente.ativo" :binary="true"/>     
                    <label>Ativo</label>                   
                </div>  
                <div class="p-field p-col-3 p-mt-2" v-if="cliente.dataCadastro">
                    <label>Data Cadastro {{ formatarData(cliente.dataCadastro) }}</label>                    
                </div>             
            </div>
        </Panel>                 
    </div>
</template>

<script>

import Cliente from '@/model/ClienteIKAcesso.js';

export default {
    clienteService: null,
    data() {
        return {
            enviandoForm: false,
            cliente: new Cliente(),  
        }
    },
    methods: {
        getDados() {
            this.enviandoForm = true;
            if(!this.cliente.nome || !this.cliente.razaoSocial 
                || !this.cliente.email || (!this.cliente.cpf && !this.cliente.cnpj)) {
                return null;
            }
            let novoCliente = {...this.cliente};
            novoCliente.cpf = this.somenteNumeros(novoCliente.cpf);
            novoCliente.cnpj = this.somenteNumeros(novoCliente.cnpj);
            novoCliente.telefone = this.somenteNumeros(novoCliente.telefone);
            novoCliente.celular = this.somenteNumeros(novoCliente.celular);
            if(novoCliente.estado) {
                novoCliente.estado = novoCliente.estado.toUpperCase();
            }           
            return novoCliente;            
        }, 
        setCliente(cliente) {
            this.cliente = cliente;
        },    
        somenteNumeros(valor) {
            if(valor) {
                return valor.replace(/[^0-9]/g,'');
            }
            return null;
        },
        formatarData(strDate) {
            if(!strDate) {
                return '';
            }
            let data = '';
            let partes = strDate.split('-');
            data = partes[2]+'/'+partes[1]+'/'+partes[0]; 
            return data;
        },        
    }
}
</script>

<style>

</style>